import { useQuery } from "@tanstack/react-query";
import { getBanner, queryKeys } from "../api/salvagers";

/** The admin-set site message, shown to everyone under the header. */
export default function Banner() {
  const { data } = useQuery({ queryKey: queryKeys.banner, queryFn: getBanner, staleTime: 5 * 60_000 });
  if (!data) return null;
  return (
    <div className={`banner ${data.level}`} role="status">
      {data.text}
    </div>
  );
}
